import { useEffect } from 'react';
import type { ThemePreference } from './auth.ts';
import { rememberTheme, showDark } from './appTheme.ts';

const DARK_QUERY = '(prefers-color-scheme: dark)';

/**
 * Colour the app the way this person chose. Without the `dark_mode` flag the app
 * is light whatever the stored choice says. Until both are known, whatever the
 * early script applied from the last visit stays.
 */
export function useAppTheme(
  preference: ThemePreference | undefined,
  darkModeEnabled: boolean | undefined,
): void {
  useEffect(() => {
    if (preference === undefined || darkModeEnabled === undefined) return;

    const theme = darkModeEnabled ? preference : 'light';
    rememberTheme(theme);

    if (theme !== 'auto') {
      showDark(theme === 'dark');
      return;
    }

    const media = window.matchMedia(DARK_QUERY);
    const follow = () => showDark(media.matches);
    follow();
    media.addEventListener('change', follow);

    return () => media.removeEventListener('change', follow);
  }, [preference, darkModeEnabled]);
}
